<template>
  <b-modal id="rejectJobModal" centered modal-class="modal-garden-help modal-confirm-message">
    <div class="d-block mb-2">
      <input id="job_id" name="job_id" type="hidden" v-model="job_id" />
      <input id="client" name="client" type="hidden" v-model="client_name" />
      <img src="@/assets/images/garden-help/close-circle.png" class="close-img" />
      <h4 class="title-confirm-modal ">Reject Job</h4>
      <p class="message-confirm-modal text-center my-3 ">
        Are you sure you want to reject this job?
      </p>
    </div>

    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100 m-0">
        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" variant="garden-help-info-outline" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="closeModalReject">
            Cancel
          </b-button>
        </b-col>
        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" variant="garden-help-danger" class="btn-bumblebee btn-garden-help mb-1 w-100"
            v-if="!is_loading" @click="clickConfirmReject">
            Yes, Reject
          </b-button>
          <b-button type="button" disabled variant="garden-help-danger" class="btn-bumblebee btn-garden-help  mb-1 w-100"
            v-else>
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>

      </b-row>
    </template>
  </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "RejectJob",
  props: ["client_name", "job_id"],
  data() {
    return {
      is_loading: false,
    };
  },

  mounted() { },

  methods: {
    clickConfirmReject() {
      console.log("in confirm reject job ", this.client_name, this.job_id);

      this.is_loading = true;
      let requestData = {
        client: this.client_name,
        status: 'rejected'
      }
      axios
        .post(
          "/jobs/job-action/" + this.job_id,
          requestData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          this.$fire({
            text: "Job is rejected successfully.",
            type: "success",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },

          }).then((r) => {
            this.$bvModal.hide("rejectJobModal");
            this.$router
              .push({ name: "GardenHelpMyJobs" })
              .catch(() => { });
          });
        })
        .catch((error) => {
          console.log(error);
          this.is_loading = false;

          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 5000,
          }).then((r) => {
          });
        });

    },
    closeModalReject() {
      this.$bvModal.hide("rejectJobModal");
    },
  },
};
</script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/modal_actions/RejectJob.vue